import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PRIORITIES } from "../lib/helpers";

const DAYS = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

export const CalendarView = ({ tasks, onOpen }) => {
  const [month, setMonth] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });

  const year = month.getFullYear(), m = month.getMonth();
  const firstOffset = (new Date(year, m, 1).getDay() + 6) % 7;
  const daysInMonth = new Date(year, m + 1, 0).getDate();
  const todayIso = new Date().toISOString().slice(0, 10);

  const byDay = {};
  tasks.forEach((t) => {
    if (!t.due_date) return;
    const key = t.due_date.slice(0, 10);
    (byDay[key] = byDay[key] || []).push(t);
  });

  const cells = [];
  for (let i = 0; i < firstOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <div className="p-4 sm:p-6 lg:p-8 h-full overflow-y-auto" data-testid="calendar-view">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display font-bold text-lg capitalize">{month.toLocaleDateString("es", { month: "long", year: "numeric" })}</h2>
        <div className="flex gap-1">
          <button onClick={() => setMonth(new Date(year, m - 1, 1))} data-testid="calendar-prev" className="bg-white/5 hover:bg-white/10 rounded-lg p-2"><ChevronLeft className="h-4 w-4" /></button>
          <button onClick={() => setMonth(new Date(year, m + 1, 1))} data-testid="calendar-next" className="bg-white/5 hover:bg-white/10 rounded-lg p-2"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-px bg-white/5 rounded-xl overflow-hidden border border-white/5">
        {DAYS.map((d) => <div key={d} className="bg-[#0E0E10] px-2 py-2 text-[11px] font-semibold uppercase tracking-wider text-zinc-500 text-center">{d}</div>)}
        {cells.map((d, i) => {
          const iso = d ? `${year}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}` : null;
          const dayTasks = iso ? byDay[iso] || [] : [];
          const isToday = iso === todayIso;
          return (
            <div key={iso || `empty-${i}`} className={`bg-[#0A0A0B] min-h-[64px] sm:min-h-[96px] p-1.5 ${!d ? "opacity-40" : ""}`} data-testid={iso ? `calendar-day-${iso}` : undefined}>
              {d && (
                <>
                  <span className={`text-xs font-semibold inline-flex h-5 w-5 items-center justify-center rounded-full ${isToday ? "bg-primary text-white" : "text-zinc-500"}`}>{d}</span>
                  <div className="space-y-1 mt-1">
                    {dayTasks.slice(0, 3).map((t) => {
                      const pr = PRIORITIES[t.priority] || PRIORITIES.medium;
                      return (
                        <button key={t.id} onClick={() => onOpen(t)} data-testid={`calendar-task-${t.id}`}
                          className="w-full text-left text-[11px] font-medium truncate px-1.5 py-0.5 rounded bg-[#1C1C1F] hover:bg-white/10 border-l-2 transition-colors"
                          style={{ borderColor: pr.color }}>{t.title}</button>
                      );
                    })}
                    {dayTasks.length > 3 && <p className="text-[10px] text-zinc-600 px-1">+{dayTasks.length - 3} más</p>}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
